import { Amplify } from 'aws-amplify'
import { env } from '../config/env'

type AmplifyOutputs = {
  auth?: {
    user_pool_id?: string
    user_pool_client_id?: string
    aws_region?: string
  }
}

let configured = false

function readAmplifyOutputs(): AmplifyOutputs | null {
  const modules = import.meta.glob<AmplifyOutputs>('../../amplify_outputs.json', {
    eager: true,
    import: 'default',
  })

  const entries = Object.values(modules)
  return entries[0] ?? null
}

export function configureAmplify(): boolean {
  if (configured) {
    return true
  }

  const outputs = readAmplifyOutputs()
  const userPoolId =
    outputs?.auth?.user_pool_id ?? env.cognitoUserPoolId
  const userPoolClientId =
    outputs?.auth?.user_pool_client_id ?? env.cognitoClientId

  if (!userPoolId || !userPoolClientId) {
    return false
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: { email: true },
      },
    },
  })

  configured = true
  return true
}

export function isAmplifyConfigured(): boolean {
  return configured
}
